// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   HEADER / TITLE
   ============================================================ */
.LeadGenIndex_leadGenWrapper__oie2L {
  width: 100%;
  margin: 0 auto;
  min-height: 700px;
}

.LeadGenIndex_headerSection__St1jk {
  text-align: center;
  margin-bottom: 32px;
  padding-bottom: 24px;
  border-bottom: 2px solid #e9ecef;
}

.LeadGenIndex_title__RAilZ {
  font-size: 2rem;
  font-weight: 700;
  color: var(--dark-color, #2d3748);
  margin-bottom: 12px;
  letter-spacing: -0.5px;
}

.LeadGenIndex_subtitle__ZOOKW {
  color: #6c757d;
  font-size: 1rem;
  line-height: 1.5;
  margin-top: 8px;
}

/* ============================================================
   HEADER ACTIONS
   ============================================================ */
.LeadGenIndex_headerActions__izEvp {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  flex-wrap: wrap;
  margin-top: 12px;
}

.LeadGenIndex_shortcutsToggleBtn__ogtUw {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: #edf2f7;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  font-size: 12px;
  cursor: pointer;
  color: #4a5568;
  transition: all 0.2s;
}

.LeadGenIndex_shortcutsToggleBtn__ogtUw:hover {
  background: #e2e8f0;
}

/* ============================================================
   LOADING / ERROR STATES
   ============================================================ */
.LeadGenIndex_loadingContainer__3VQSS {
  padding: 40px;
  text-align: center;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border-radius: 12px;
  max-width: 500px;
  margin: 40px auto;
}

.LeadGenIndex_loadingSpinner__DC-v1 {
  width: 50px;
  height: 50px;
  border: 3px solid #e9ecef;
  border-top-color: #667eea;
  border-radius: 50%;
  animation: LeadGenIndex_spin__meOOi 0.8s linear infinite;
  margin: 0 auto 20px;
}

@keyframes LeadGenIndex_spin__meOOi {
  to {
    transform: rotate(360deg);
  }
}

.LeadGenIndex_loadingTitle__rDCVR {
  color: #495057;
  margin-bottom: 16px;
  font-size: 1.25rem;
}

.LeadGenIndex_loadingText__wwcTb {
  color: #6c757d;
  margin: 8px 0;
}

.LeadGenIndex_errorContainer__lvBOi {
  padding: 16px 20px;
  background: linear-gradient(135deg, #ffebee 0%, #ffcdd2 100%);
  color: #c62828;
  border-radius: 8px;
  border-left: 4px solid #c62828;
  margin: 20px;
  display: flex;
  align-items: center;
  gap: 12px;
}

.LeadGenIndex_errorIcon__uc3xZ {
  font-size: 20px;
  color: #e53e3e;
  cursor: help;
}

/* ============================================================
   FORMS SECTION
   ============================================================ */
.LeadGenIndex_formsSection__Q3tJG {
  margin-top: 32px;
}

.LeadGenIndex_sectionHeader__sonYP {
  margin-bottom: 24px;
}

.LeadGenIndex_sectionTitle__AM4GH {
  font-size: 1.5rem;
  font-weight: 600;
  color: #495057;
  margin-bottom: 8px;
}

.LeadGenIndex_sectionSubtitle__2PDXx {
  color: #6c757d;
  font-size: 0.875rem;
}

.LeadGenIndex_formsGrid__wQ3uQ {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.LeadGenIndex_formCard__CuRvT {
  border-radius: 12px;
  padding: 24px;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  animation: LeadGenIndex_slideIn__\\+D8ch 0.3s ease-out;
}

.LeadGenIndex_formCard__CuRvT:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
}

.LeadGenIndex_formCardMapped__PN7wU {
  border-left: 4px solid #28a745;
  background: linear-gradient(135deg, #ffffff 0%, #f0f9f0 100%);
}

.LeadGenIndex_formCardUnmapped__Wajja {
  background: var(--white-color, #ffffff);
  border: 1px solid #e9ecef;
  border-left: 4px solid #ff9800;
}

.LeadGenIndex_formCardHeader__xdhak {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 2px solid #e9ecef;
}

.LeadGenIndex_formTitleSection__eo7CC {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.LeadGenIndex_formTitle__mF3vd {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: #495057;
}

.LeadGenIndex_badgeMapped__dS6Kq {
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  color: white;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.LeadGenIndex_badgeUnmapped__Dfv46 {
  background: linear-gradient(135deg, #ff9800 0%, #fb8c00 100%);
  color: white;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.LeadGenIndex_badgeFieldsMapped__NVeQu {
  background: linear-gradient(135deg, #805ad5 0%, #6b46c1 100%);
  color: white;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.LeadGenIndex_formFieldsSection__FvJn7 {
  margin-bottom: 16px;
}

.LeadGenIndex_formFieldsLabel__i7d0E {
  font-weight: 600;
  margin-bottom: 8px;
  color: #495057;
  font-size: 0.875rem;
}

.LeadGenIndex_formFieldsList__yI-p5 {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.LeadGenIndex_fieldTag__zvoqq {
  padding: 6px 12px;
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdef5 100%);
  border-radius: 6px;
  font-size: 0.813rem;
  font-family: "Courier New", monospace;
  color: #1976d2;
  border: 1px solid #90caf9;
}

.LeadGenIndex_requiredStar__-A5eX {
  color: #dc3545;
  margin-left: 3px;
  font-weight: bold;
}

/* ============================================================
   FORM CONFIG / SELECT
   ============================================================ */
.LeadGenIndex_apiConfigSection__zJGfi {
  margin-bottom: 16px;
}

.LeadGenIndex_formLabel__Kr04L {
  display: block;
  font-weight: 600;
  margin-bottom: 8px;
  color: #495057;
  font-size: 0.875rem;
}

.LeadGenIndex_selectWrapper__1rNOR {
  position: relative;
  display: inline-block;
  width: 100%;
}

.LeadGenIndex_selectIcon__vR7Le {
  position: absolute;
  right: 10px;
  top: 40%;
  transform: translateY(-50%);
  pointer-events: none;
  color: #666;
}

.LeadGenIndex_selectInput__lQWny {
  width: 100%;
  padding: 10px 12px;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  font-size: 0.875rem;
  transition: all 0.3s ease;
  background-color: white;
  margin-bottom: 12px;
}

.LeadGenIndex_selectInput__lQWny:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.LeadGenIndex_customSelect__RGGEu {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  padding-right: 30px;
  cursor: pointer;
}

.LeadGenIndex_customSelect__RGGEu::-ms-expand {
  display: none;
}

.LeadGenIndex_mapButton__-kz-g {
  padding: 10px 20px;
  background: var(--saveHover, #48bb78);
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 600;
  transition: all 0.3s ease;
  width: 100%;
}

.LeadGenIndex_mapButton__-kz-g:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(76, 175, 80, 0.3);
}

.LeadGenIndex_mapFieldsBtn__-Dn\\+x {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-left: 12px;
  padding: 4px 12px;
  background: #4a90d9;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  transition: background 0.2s;
}

.LeadGenIndex_mapFieldsBtn__-Dn\\+x:hover {
  background: #357abd;
}

/* ============================================================
   MAPPED CONFIG INFO
   ============================================================ */
.LeadGenIndex_mappedConfigInfo__V4izK {
  margin-top: 16px;
  padding: 16px;
  background: linear-gradient(135deg, #f5f5f5 0%, #e9ecef 100%);
  border-radius: 8px;
  border-left: 3px solid #4caf50;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.LeadGenIndex_mappedConfigInfo__V4izK strong {
  background-color: transparent;
  color: #999;
  margin-bottom: 15px;
  border-radius: 12px;
  word-wrap: break-word;
}

.LeadGenIndex_configDetails__dvF-Q {
  margin-top: 12px;
}

.LeadGenIndex_configRow__bBQ7b {
  margin: 8px 0;
  font-size: 0.875rem;
}

.LeadGenIndex_configLabel__9ihuW {
  font-weight: 600;
  color: #495057;
  margin-right: 8px;
}

.LeadGenIndex_configValue__A12T7 {
  color: #6c757d;
  font-family: "Courier New", monospace;
}

.LeadGenIndex_configSummary__UjfeE {
  cursor: pointer;
  color: #667eea;
  font-weight: 600;
  font-size: 0.875rem;
  margin-top: 8px;
}

.LeadGenIndex_configPre__xoRW2 {
  font-size: 11px;
  white-space: pre-wrap;
  background-color: #ffffff;
  padding: 12px;
  border-radius: 6px;
  margin-top: 8px;
  border: 1px solid #dee2e6;
  overflow-x: auto;
}

/* ============================================================
   MODAL SHELL
   ============================================================ */
.LeadGenIndex_modalOverlay__K83I6 {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.LeadGenIndex_modalContent__vtQ7j {
  background: white;
  border-radius: 12px;
  max-width: 1100px;
  width: 95%;
  max-height: 88vh;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
}

.LeadGenIndex_modalHeader__1mFDP {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 24px;
  border-bottom: 1px solid #e2e8f0;
  flex-shrink: 0;
}

.LeadGenIndex_modalHeader__1mFDP h3 {
  margin: 0;
  color: #2d3748;
  font-size: 18px;
}

.LeadGenIndex_modalHeaderActions__rJ\\+L6 {
  display: flex;
  align-items: center;
  gap: 12px;
}

.LeadGenIndex_modalCloseBtn__p3uWM {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #a0aec0;
  padding: 0 8px;
  line-height: 1;
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  padding: 4px 8px;
  border-radius: 4px;
}

.LeadGenIndex_modalCloseBtn__p3uWM:hover {
  background: #f0f0f0;
  color: #333;
}

.LeadGenIndex_modalBody__vRMOS {
  padding: 24px;
  overflow-y: auto;
  flex: 1 1;
}

/* ============================================================
   MODAL HEADER ACTIONS
   ============================================================ */
.LeadGenIndex_unsavedIndicator__3\\+rQq {
  font-size: 12px;
  color: #e53e3e;
  font-weight: 500;
  animation: LeadGenIndex_pulse__Lg7j6 1.5s ease-in-out infinite;
}

@keyframes LeadGenIndex_pulse__Lg7j6 {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

.LeadGenIndex_clearAllBtn__wMvtH {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 12px;
  background: transparent;
  color: #4299e1;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
  border: 1px solid #4299e1;
}

.LeadGenIndex_clearAllBtn__wMvtH:hover {
  background: #b4ddff;
}

/* ============================================================
   MODAL INFO / CONFIG BLOCK
   ============================================================ */
.LeadGenIndex_mappingInfo__LDKDc {
  color: #4a5568;
  margin-bottom: 16px;
  font-size: 14px;
}

.LeadGenIndex_selectedConfigInfo__W5E7P {
  background: #f7fafc;
  padding: 12px 16px;
  border-radius: 6px;
  margin-bottom: 20px;
  font-size: 14px;
  color: #2d3748;
}

.LeadGenIndex_configUrl__Zof6c {
  margin-bottom: 6px;
  word-break: break-word;
}

.LeadGenIndex_configStructure__SxFQh {
  margin-top: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: center;
}

.LeadGenIndex_structureLabel__yYadr {
  font-size: 13px;
  color: #4a5568;
  font-weight: 500;
}

.LeadGenIndex_structureBadge__HCvnx {
  font-size: 11px;
  padding: 6px 10px;
  border-radius: 40px;
  font-weight: 500;
  white-space: nowrap;
}

.LeadGenIndex_structureBadge__HCvnx.LeadGenIndex_path__I6\\+8O {
  background: #fef3c7;
  color: #92400e;
}
.LeadGenIndex_structureBadge__HCvnx.LeadGenIndex_query__PzCOs {
  background: #dbeafe;
  color: #1e40af;
}
.LeadGenIndex_structureBadge__HCvnx.LeadGenIndex_payload__bItNO {
  background: #d1fae5;
  color: #065f46;
}

.LeadGenIndex_mappingProgress__rZNFc {
  margin-top: 12px;
  font-size: 13px;
  color: #4a5568;
}

.LeadGenIndex_progressBar__HHYs2 {
  margin-top: 6px;
  height: 8px;
  background: #e2e8f0;
  border-radius: 4px;
  overflow: hidden;
}

.LeadGenIndex_progressFill__Fyzw1 {
  height: 100%;
  background: linear-gradient(90deg, #48bb78, #38a169);
  transition: width 0.3s ease;
  border-radius: 4px;
}

/* ============================================================
   STRICT AUTH / CHECKBOX
   ============================================================ */
.LeadGenIndex_strictAuthSection__wt-gD {
  margin-bottom: 16px;
  padding: 12px;
  background-color: #f8f9fa;
  border-radius: 6px;
}

.LeadGenIndex_checkboxLabel__R3bLO {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  font-size: 13px;
  color: #2d3748;
}

.LeadGenIndex_checkbox__3DSI3 {
  width: 18px;
  height: 18px;
  cursor: pointer;
  accent-color: var(--saveBtn, #4a90d9);
  color: var(--white-color, #ffffff);
}

.LeadGenIndex_helperText__ZaPRp {
  color: #6c757d;
  font-size: 0.75rem;
}

/* ============================================================
   TABS
   ============================================================ */
.LeadGenIndex_tabs__X8xHJ {
  display: flex;
  gap: 4px;
  margin: 16px 0;
  border-bottom: 2px solid #e2e8f0;
  flex-wrap: wrap;
}

.LeadGenIndex_tab__D94Ge {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  cursor: pointer;
  color: #4a5568;
  font-weight: 500;
  transition: all 0.2s;
  margin-bottom: -2px;
}

.LeadGenIndex_tab__D94Ge:hover {
  color: #2d3748;
}

.LeadGenIndex_tabActive__wZOsW {
  color: #4a90d9;
  border-bottom-color: #4a90d9;
}

.LeadGenIndex_tabDisabled__W8HGi {
  opacity: 0.5;
  cursor: not-allowed;
  color: #a0aec0;
}

.LeadGenIndex_tabDisabled__W8HGi:hover {
  color: #a0aec0;
}

.LeadGenIndex_tabBadge__7SKwU {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  margin-left: 6px;
  background: #edf2f7;
  padding: 1px 8px;
  border-radius: 10px;
  font-size: 11px;
  color: #4a5568;
}

.LeadGenIndex_tabActive__wZOsW .LeadGenIndex_tabBadge__7SKwU {
  background: #bee3f8;
  color: #2b6cb0;
}

.LeadGenIndex_requiredAsterisk__wRh3- {
  color: #e53e3e;
  font-weight: bold;
  font-size: 14px;
  margin-left: 1px;
}

/* ============================================================
   AUTO-MAP BUTTON
   ============================================================ */
.LeadGenIndex_autoMapBtn__jHDgN {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 14px;
  background: #e9d8fd;
  color: #553c9a;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 13px;
  margin-bottom: 12px;
  transition: background 0.2s;
}

.LeadGenIndex_autoMapBtn__jHDgN:hover {
  background: #d6bcfa;
}

/* ============================================================
   MAPPING TABLE
   ============================================================ */
.LeadGenIndex_mappingTable__e48IV {
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  overflow: hidden;
  background: #ffffff;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04);
}

/* ---------- Header (6 columns) ---------- */
.LeadGenIndex_mappingHeader__qkaM7 {
  display: grid;
  grid-template-columns:
    minmax(180px, 1.4fr) /* API Parameter */
    32px /* → arrow       */
    minmax(160px, 1.6fr) /* Form Field    */
    minmax(110px, 0.9fr) /* Convert To    */
    minmax(90px, 0.7fr) /* Location      */
    minmax(60px, 0.4fr); /* Template      */
  align-items: center;
  column-gap: 10px;
  padding: 12px 16px;
  background: #f7fafc;
  font-weight: 700;
  font-size: 11.5px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #718096;
  border-bottom: 1px solid #e2e8f0;
  position: sticky;
  top: 0;
  z-index: 1;
}

.LeadGenIndex_mappingHeader__qkaM7 .LeadGenIndex_mappingColumn__\\+OXNb {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  align-items: center;
}

.LeadGenIndex_mappingHeader__qkaM7 .LeadGenIndex_mappingColumn__\\+OXNb:nth-child(2),
.LeadGenIndex_mappingHeader__qkaM7 .LeadGenIndex_mappingColumn__\\+OXNb:nth-child(5),
.LeadGenIndex_mappingHeader__qkaM7 .LeadGenIndex_mappingColumn__\\+OXNb:nth-child(6) {
  justify-content: center;
}

/* ---------- Row wrapper: block, not grid ---------- */
.LeadGenIndex_mappingRow__UjMb7 {
  display: block;
  padding: 12px 16px;
  border-bottom: 1px solid #f0f0f0;
  font-size: 13px;
  transition: background 0.15s ease;
}

.LeadGenIndex_mappingRow__UjMb7:last-child {
  border-bottom: none;
}

.LeadGenIndex_mappingRow__UjMb7:hover {
  background: #fafbfc;
}

.LeadGenIndex_mappingRowHasTemplate__EuJJr {
  background: #fdfcff;
}

/* ---------- Row main line: 6 columns ---------- */
.LeadGenIndex_mappingRowMain__PiGYB {
  display: grid;
  grid-template-columns:
    minmax(180px, 1.4fr)
    32px
    minmax(160px, 1.6fr)
    minmax(110px, 0.9fr)
    minmax(90px, 0.7fr)
    minmax(60px, 0.4fr);
  align-items: center;
  column-gap: 10px;
}

.LeadGenIndex_mappingColumn__\\+OXNb {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  overflow: hidden;
  font-size: 13px;
  color: #2d3748;
  line-height: 1.35;
}

/* ---------- Col 1: param header block ---------- */
.LeadGenIndex_mappingRowMain__PiGYB .LeadGenIndex_mappingColumn__\\+OXNb:nth-child(1) {
  display: block;
  min-width: 0;
}

.LeadGenIndex_paramHeader__PqGJL {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  min-width: 0;
}

.LeadGenIndex_mappingRowMain__PiGYB .LeadGenIndex_mappingColumn__\\+OXNb:nth-child(1) .LeadGenIndex_fieldName__ymrBV {
  font-weight: 600;
  color: #2d3748;
  font-family: "SF Mono", Menlo, Consolas, monospace;
  font-size: 12.5px;
  word-break: break-word;
}

.LeadGenIndex_fieldType__cUSgB {
  font-size: 10.5px;
  color: #718096;
  white-space: nowrap;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.LeadGenIndex_compatBadge__-K9Qs {
  display: inline-flex;
  align-items: center;
  font-size: 10px;
  font-weight: 600;
  color: white;
  padding: 1px 6px;
  border-radius: 8px;
  white-space: nowrap;
  letter-spacing: 0.02em;
}

.LeadGenIndex_compatReason__OSCc9 {
  font-size: 10.5px;
  color: #a0aec0;
  margin-top: 3px;
  line-height: 1.3;
}

/* ---------- Col 2: arrow ---------- */
.LeadGenIndex_mappingRowMain__PiGYB .LeadGenIndex_mappingColumn__\\+OXNb:nth-child(2) {
  justify-content: center;
  color: #cbd5e0;
  font-size: 14px;
  -webkit-user-select: none;
          user-select: none;
}

.LeadGenIndex_mappingArrow__PaUS6 {
  font-size: 12px;
}

/* ---------- Cols 3-4: selects ---------- */
.LeadGenIndex_mappingRowMain__PiGYB .LeadGenIndex_mappingColumn__\\+OXNb:nth-child(3),
.LeadGenIndex_mappingRowMain__PiGYB .LeadGenIndex_mappingColumn__\\+OXNb:nth-child(4) {
  justify-content: stretch;
  min-width: 0;
}

.LeadGenIndex_mappingRowMain__PiGYB .LeadGenIndex_mappingColumn__\\+OXNb:nth-child(3) > *,
.LeadGenIndex_mappingRowMain__PiGYB .LeadGenIndex_mappingColumn__\\+OXNb:nth-child(4) > * {
  width: 100%;
  min-width: 0;
}

/* ---------- Cols 5-6: badge + toggle ---------- */
.LeadGenIndex_mappingRowMain__PiGYB .LeadGenIndex_mappingColumn__\\+OXNb:nth-child(5),
.LeadGenIndex_mappingRowMain__PiGYB .LeadGenIndex_mappingColumn__\\+OXNb:nth-child(6) {
  justify-content: center;
}

/* ============================================================
   FIELD NAME / TYPE
   ============================================================ */
.LeadGenIndex_fieldName__ymrBV {
  font-weight: 600;
  color: #2d3748;
  font-family: "SF Mono", Menlo, Consolas, monospace;
  font-size: 12.5px;
  word-break: break-word;
}

/* ============================================================
   MAPPING SELECT / INPUT
   ============================================================ */
.LeadGenIndex_mappingSelect__BQnDq,
.LeadGenIndex_conversionSelect__x1Xc\\+,
.LeadGenIndex_mappingInput__jYMG0 {
  width: 100%;
  min-width: 0;
  padding: 6px 26px 6px 8px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  font-size: 12px;
  font-family: "SF Mono", Menlo, Consolas, monospace;
  background: #fff;
  color: #2d3748;
  appearance: none;
  cursor: pointer;
  transition:
    border-color 0.15s,
    box-shadow 0.15s;
}

.LeadGenIndex_mappingSelect__BQnDq:focus,
.LeadGenIndex_mappingInput__jYMG0:focus {
  outline: none;
  border-color: #4a90d9;
  box-shadow: 0 0 0 3px rgba(74, 144, 217, 0.15);
}

.LeadGenIndex_selectWrapperSmall__UASJV {
  position: relative;
  width: 100%;
  min-width: 0;
  flex: 1 1;
}

.LeadGenIndex_selectIconSmall__EW40i {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  color: #a0aec0;
  pointer-events: none;
  font-size: 10px;
}

/* ---------- Location-coloured selects (optional, kept for future use) ---------- */
.LeadGenIndex_mappingSelect__BQnDq.LeadGenIndex_pathParam__nRA2r {
  border-color: #f59e0b;
}
.LeadGenIndex_mappingSelect__BQnDq.LeadGenIndex_pathParam__nRA2r:focus {
  border-color: #f59e0b;
  box-shadow: 0 0 0 3px rgba(245, 158, 11, 0.2);
}
.LeadGenIndex_mappingSelect__BQnDq.LeadGenIndex_queryParam__bkmbZ {
  border-color: #3b82f6;
}
.LeadGenIndex_mappingSelect__BQnDq.LeadGenIndex_queryParam__bkmbZ:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.2);
}
.LeadGenIndex_mappingSelect__BQnDq.LeadGenIndex_payloadParam__-5EEx {
  border-color: #10b981;
}
.LeadGenIndex_mappingSelect__BQnDq.LeadGenIndex_payloadParam__-5EEx:focus {
  border-color: #10b981;
  box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.2);
}

.LeadGenIndex_mappingInput__jYMG0.LeadGenIndex_pathParam__nRA2r {
  border-color: #f59e0b;
}
.LeadGenIndex_mappingInput__jYMG0.LeadGenIndex_pathParam__nRA2r:focus {
  border-color: #f59e0b;
  box-shadow: 0 0 0 3px rgba(245, 158, 11, 0.2);
}
.LeadGenIndex_mappingInput__jYMG0.LeadGenIndex_queryParam__bkmbZ {
  border-color: #3b82f6;
}
.LeadGenIndex_mappingInput__jYMG0.LeadGenIndex_queryParam__bkmbZ:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.2);
}
.LeadGenIndex_mappingInput__jYMG0.LeadGenIndex_payloadParam__-5EEx {
  border-color: #10b981;
}
.LeadGenIndex_mappingInput__jYMG0.LeadGenIndex_payloadParam__-5EEx:focus {
  border-color: #10b981;
  box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.2);
}

/* ---------- Location badge ---------- */
.LeadGenIndex_locationBadge__L1fCw {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 10.5px;
  padding: 3px 8px;
  border-radius: 10px;
  font-weight: 600;
  letter-spacing: 0.02em;
  white-space: nowrap;
}

.LeadGenIndex_locationBadge__L1fCw.LeadGenIndex_path__I6\\+8O {
  background: #fef3c7;
  color: #92400e;
}
.LeadGenIndex_locationBadge__L1fCw.LeadGenIndex_query__PzCOs {
  background: #dbeafe;
  color: #1e40af;
}
.LeadGenIndex_locationBadge__L1fCw.LeadGenIndex_payload__bItNO {
  background: #d1fae5;
  color: #065f46;
}

/* ---------- Error select ---------- */
.LeadGenIndex_mappingSelectError__3fBlS {
  border-color: #e53e3e !important;
}

.LeadGenIndex_mappingSelectError__3fBlS:focus {
  border-color: #e53e3e !important;
  box-shadow: 0 0 0 3px rgba(229, 62, 62, 0.2) !important;
}

/* ============================================================
   TEMPLATE TOGGLE + EDITOR
   ============================================================ */
.LeadGenIndex_templateToggleBtn__igihW {
  padding: 5px 10px;
  font-size: 12px;
  border-radius: 6px;
  border: 1px solid #e2e8f0;
  background-color: white;
  color: #4a5568;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.15s ease;
  font-family: system-ui;
  line-height: 1.2;
}

.LeadGenIndex_templateToggleBtn__igihW:hover {
  background-color: #edf2f7;
  border-color: #cbd5e0;
}

.LeadGenIndex_templateToggleBtnActive__LMAh8 {
  border-color: #9f7aea;
  background-color: #faf5ff;
  color: #6b46c1;
}

.LeadGenIndex_templateToggleBtnActive__LMAh8:hover {
  background-color: #f3e8ff;
}

.LeadGenIndex_templateEditor__YJsu2 {
  margin-top: 12px;
  padding: 12px 14px;
  background-color: #fafafa;
  border-radius: 8px;
  border: 1px solid #e9e3f5;
}

.LeadGenIndex_templateEditorHint__ZBFBC {
  font-size: 11.5px;
  color: #4a5568;
  margin-bottom: 8px;
  line-height: 1.5;
}

.LeadGenIndex_templateEditorHint__ZBFBC code {
  background-color: #edf2f7;
  padding: 1px 5px;
  border-radius: 3px;
  font-family: "SF Mono", Menlo, Consolas, monospace;
  font-size: 11px;
}

.LeadGenIndex_templateTextarea__w\\+FTI {
  width: 100%;
  box-sizing: border-box;
  font-family: "SF Mono", Menlo, Consolas, monospace;
  font-size: 12px;
  padding: 8px 10px;
  border-radius: 6px;
  border: 1px solid #cbd5e0;
  background-color: white;
  resize: vertical;
  line-height: 1.5;
  color: #2d3748;
}

.LeadGenIndex_templateTextarea__w\\+FTI:focus {
  outline: none;
  border-color: #9f7aea;
  box-shadow: 0 0 0 3px rgba(159, 122, 234, 0.15);
}

.LeadGenIndex_templateFieldChips__TaOob {
  margin-top: 8px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
}

.LeadGenIndex_templateFieldChipsLabel__na1tv {
  font-size: 10.5px;
  color: #718096;
  margin-right: 4px;
  font-weight: 500;
}

.LeadGenIndex_templateFieldChip__aRFMZ {
  padding: 2px 8px;
  font-size: 10.5px;
  border-radius: 10px;
  border: 1px solid #cbd5e0;
  background-color: white;
  color: #4a5568;
  cursor: pointer;
  font-family: "SF Mono", Menlo, Consolas, monospace;
  transition: all 0.15s ease;
  line-height: 1.4;
}

.LeadGenIndex_templateFieldChip__aRFMZ:hover {
  background-color: #faf5ff;
  border-color: #9f7aea;
  color: #6b46c1;
}

.LeadGenIndex_templatePreview__-7UgV {
  margin-top: 10px;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 11.5px;
}

.LeadGenIndex_templatePreviewJson__y6JTU {
  background-color: #f0fff4;
  border: 1px solid #9ae6b4;
}

.LeadGenIndex_templatePreviewString__UTlp8 {
  background-color: #ebf8ff;
  border: 1px solid #90cdf4;
}

.LeadGenIndex_templatePreviewEmpty__mg3ju {
  background-color: #fffaf0;
  border: 1px solid #f6ad55;
}

.LeadGenIndex_templatePreviewLabel__6CdJj {
  font-weight: 600;
  margin-bottom: 4px;
  font-size: 11px;
}

.LeadGenIndex_templatePreviewJson__y6JTU .LeadGenIndex_templatePreviewLabel__6CdJj {
  color: #22543d;
}

.LeadGenIndex_templatePreviewString__UTlp8 .LeadGenIndex_templatePreviewLabel__6CdJj {
  color: #2a4365;
}

.LeadGenIndex_templatePreviewEmpty__mg3ju .LeadGenIndex_templatePreviewLabel__6CdJj {
  color: #744210;
}

.LeadGenIndex_templatePreviewValue__-Bv1B {
  font-size: 11.5px;
  word-break: break-all;
  white-space: pre-wrap;
  color: #2d3748;
  font-family: "SF Mono", Menlo, Consolas, monospace;
  display: block;
  line-height: 1.5;
}

/* ============================================================
   STRUCTURE SECTIONS / UNUSED FIELDS
   ============================================================ */
.LeadGenIndex_structureSection__wloDi {
  margin-top: 12px;
  padding: 12px 16px;
  background: #f7fafc;
  border-radius: 6px;
}

.LeadGenIndex_structureSection__wloDi h4 {
  margin: 0 0 4px 0;
  font-size: 14px;
  color: #2d3748;
  display: flex;
  align-items: center;
  gap: 6px;
}

.LeadGenIndex_structureSection__wloDi p {
  margin: 0 0 8px 0;
  font-size: 13px;
  color: #4a5568;
}

.LeadGenIndex_apiStructureDetails__qdxPN {
  margin-top: 16px;
  padding: 12px 16px;
  background: #f7fafc;
  border-radius: 6px;
}

.LeadGenIndex_paramList__owWMv {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.LeadGenIndex_paramTag__pnhNQ {
  font-size: 12px;
  padding: 3px 10px;
  border-radius: 12px;
  font-family: monospace;
  background: #e2e8f0;
  color: #2d3748;
}

.LeadGenIndex_paramTag__pnhNQ.LeadGenIndex_path__I6\\+8O {
  background: #fef3c7;
  color: #92400e;
}
.LeadGenIndex_paramTag__pnhNQ.LeadGenIndex_query__PzCOs {
  background: #dbeafe;
  color: #1e40af;
}
.LeadGenIndex_paramTag__pnhNQ.LeadGenIndex_payload__bItNO {
  background: #d1fae5;
  color: #065f46;
}

.LeadGenIndex_paramTag__pnhNQ.LeadGenIndex_static__uTKb9 {
  background: #edf2f7;
  color: #4a5568;
  opacity: 0.7;
  text-decoration: line-through;
}

.LeadGenIndex_staticBadge__iAcng {
  font-size: 9px;
  background: #e2e8f0;
  color: #4a5568;
  padding: 1px 6px;
  border-radius: 8px;
  margin-left: 4px;
  font-family: system-ui;
  text-decoration: none;
}

/* ============================================================
   VALIDATION
   ============================================================ */
.LeadGenIndex_validationSummary__xZwTa {
  margin-top: 12px;
  padding: 12px 16px;
  background: #fff5f5;
  border: 1px solid #feb2b2;
  border-radius: 6px;
  color: #9b2c2c;
  font-size: 13px;
}

.LeadGenIndex_validationSummary__xZwTa ul {
  margin: 4px 0 0 20px;
  padding: 0;
}

.LeadGenIndex_validationSummary__xZwTa li {
  margin: 2px 0;
}

/* ============================================================
   MODAL ACTIONS
   ============================================================ */
.LeadGenIndex_modalActions__XnvTq {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid #e2e8f0;
}

.LeadGenIndex_modalActionsLeft__B0bx9 {
  display: flex;
  align-items: center;
}

.LeadGenIndex_modalActionsRight__owFIt {
  display: flex;
  align-items: center;
  gap: 12px;
}

.LeadGenIndex_shortcutHint__D7b-K {
  font-size: 12px;
  color: #a0aec0;
  display: flex;
  align-items: center;
  gap: 4px;
}

.LeadGenIndex_cancelBtn__BViEv {
  padding: 8px 20px;
  background: #edf2f7;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  color: #4a5568;
}

.LeadGenIndex_cancelBtn__BViEv:hover {
  background: #e2e8f0;
}

.LeadGenIndex_saveMappingsBtn__LyaIf {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 24px;
  background: #4a90d9;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 500;
}

.LeadGenIndex_saveMappingsBtn__LyaIf:hover {
  background: #357abd;
}

.LeadGenIndex_saveMappingsBtn__LyaIf:disabled {
  background: #cbd5e0;
  cursor: not-allowed;
}

.LeadGenIndex_saveMappingsBtn__LyaIf svg {
  font-size: 14px;
}

/* ============================================================
   KEYBOARD SHORTCUTS MODAL
   ============================================================ */
.LeadGenIndex_shortcutsOverlay__kwFWL {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}

.LeadGenIndex_shortcutsContent__I6-lc {
  background: white;
  border-radius: 12px;
  max-width: 400px;
  width: 90%;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
}

.LeadGenIndex_shortcutsHeader__ENuJp {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
  border-bottom: 1px solid #e2e8f0;
}

.LeadGenIndex_shortcutsHeader__ENuJp h3 {
  margin: 0;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  color: #2d3748;
}

.LeadGenIndex_shortcutsCloseBtn__EadG3 {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #a0aec0;
}

.LeadGenIndex_shortcutsCloseBtn__EadG3:hover {
  color: #4a5568;
}

.LeadGenIndex_shortcutsBody__HDEeT {
  padding: 20px 24px;
}

.LeadGenIndex_shortcutRow__zsYft {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;
}

.LeadGenIndex_shortcutRow__zsYft:last-child {
  border-bottom: none;
}

.LeadGenIndex_shortcutKey__4yeVU {
  font-family: monospace;
  font-weight: 600;
  color: #2d3748;
  background: #edf2f7;
  padding: 2px 10px;
  border-radius: 4px;
  font-size: 13px;
}

.LeadGenIndex_shortcutDesc__iPSnX {
  color: #4a5568;
  font-size: 13px;
}

/* ============================================================
   EDIT / FIELD SUMMARY / DATA SOURCE
   ============================================================ */
.LeadGenIndex_configSelectedIndicator__cY0rt {
  display: inline-block;
  margin-left: 12px;
  color: #48bb78;
  font-size: 13px;
  font-weight: 500;
}

.LeadGenIndex_editMappingBtn__Iei8y {
  padding: 8px 20px;
  background: var(--editBtn);
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 500;
  transition: all 0.2s ease;
}

.LeadGenIndex_editMappingBtn__Iei8y:hover {
  background: var(--editHover);
}
.LeadGenIndex_deleteMappingBtn__7E5Ng {
  padding: 8px 20px;
  background: var(--deleteBtn);
  color: var(--white-color);
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 500;
  transition: all 0.2s ease;
}
.LeadGenIndex_deleteMappingBtn__7E5Ng:hover {
  background: var(--deleteHover);
}
.LeadGenIndex_fieldMappingsSummary__3cUbL {
  margin-top: 8px;
  padding: 8px 12px;
  background: #f7fafc;
  border-radius: 4px;
}

.LeadGenIndex_mappingTags__p2Bcu {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-top: 4px;
}

.LeadGenIndex_mappingTag__V3hI0 {
  background: #e9d8fd;
  color: #553c9a;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 11px;
  font-family: monospace;
}

.LeadGenIndex_dataSourceIndicator__IMGpl {
  margin-top: 12px;
  padding: 8px 16px;
  background: #f0f4ff;
  border-radius: 6px;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.LeadGenIndex_dataSourceLabel__tkZGT {
  font-weight: 600;
  color: #4a5568;
}

.LeadGenIndex_dataSourceValue__gPUHO {
  color: #2b6cb0;
  font-weight: 500;
}

.LeadGenIndex_badgeNewTable__a29V\\+ {
  font-size: 10px;
  padding: 2px 8px;
  border-radius: 12px;
  background: #48bb78;
  color: white;
  font-weight: 600;
  margin-left: 8px;
}

.LeadGenIndex_badgeLegacy__dK8eQ {
  font-size: 10px;
  padding: 2px 8px;
  border-radius: 12px;
  background: #a0aec0;
  color: white;
  font-weight: 600;
  margin-left: 8px;
}

/* ============================================================
   EMPTY STATE
   ============================================================ */
.LeadGenIndex_emptyState__JLKJu {
  text-align: center;
  padding: 40px;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 12px;
  color: #6c757d;
}

/* ============================================================
   ANIMATIONS
   ============================================================ */
@keyframes LeadGenIndex_slideIn__\\+D8ch {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* ============================================================
   RESPONSIVE
   ============================================================ */
@media (max-width: 768px) {
  .LeadGenIndex_leadGenWrapper__oie2L {
    padding: 16px;
  }

  .LeadGenIndex_title__RAilZ {
    font-size: 1.5rem;
  }

  .LeadGenIndex_formCard__CuRvT {
    padding: 16px;
  }

  .LeadGenIndex_formTitleSection__eo7CC {
    flex-direction: column;
    align-items: flex-start;
  }

  .LeadGenIndex_fieldTag__zvoqq {
    font-size: 0.75rem;
  }

  .LeadGenIndex_modalActions__XnvTq {
    flex-direction: column;
    align-items: stretch;
  }

  .LeadGenIndex_modalActionsRight__owFIt {
    justify-content: flex-end;
  }
}

@media (max-width: 900px) {
  .LeadGenIndex_mappingHeader__qkaM7,
  .LeadGenIndex_mappingRowMain__PiGYB {
    grid-template-columns:
      minmax(150px, 1.4fr)
      28px
      minmax(140px, 1.5fr)
      minmax(100px, 0.9fr)
      minmax(80px, 0.7fr)
      minmax(56px, 0.4fr);
    column-gap: 8px;
  }
}

@media (max-width: 720px) {
  /* ---------- Stack the mapping table into cards ---------- */
  .LeadGenIndex_mappingHeader__qkaM7 {
    display: none;
  }

  .LeadGenIndex_mappingRowMain__PiGYB {
    grid-template-columns: 1fr;
    row-gap: 10px;
  }

  .LeadGenIndex_mappingRowMain__PiGYB .LeadGenIndex_mappingColumn__\\+OXNb {
    display: grid;
    grid-template-columns: 110px 1fr;
    align-items: center;
    column-gap: 10px;
    width: 100%;
    padding: 4px 0;
    border-bottom: 1px dashed #edf2f7;
    overflow: visible;
  }

  .LeadGenIndex_mappingRowMain__PiGYB .LeadGenIndex_mappingColumn__\\+OXNb:last-child {
    border-bottom: none;
  }

  .LeadGenIndex_mappingRowMain__PiGYB .LeadGenIndex_mappingColumn__\\+OXNb::before {
    content: attr(data-label);
    font-size: 10.5px;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: #a0aec0;
    font-weight: 700;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .LeadGenIndex_mappingRowMain__PiGYB .LeadGenIndex_mappingColumn__\\+OXNb:nth-child(2) {
    display: none;
  }

  .LeadGenIndex_mappingRowMain__PiGYB .LeadGenIndex_mappingColumn__\\+OXNb:nth-child(1) {
    display: block;
    padding-bottom: 8px;
    margin-bottom: 4px;
    border-bottom: 1px solid #e2e8f0;
  }

  .LeadGenIndex_mappingRowMain__PiGYB .LeadGenIndex_mappingColumn__\\+OXNb:nth-child(1)::before {
    display: none;
  }
}

@media (max-width: 480px) {
  .LeadGenIndex_leadGenWrapper__oie2L {
    padding: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/Component/SideData/Overview/AiAgentWorkFlow/LeadGenIndex.module.css"],"names":[],"mappings":"AAAA;;iEAEiE;AACjE;EACE,WAAW;EACX,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;iEAEiE;AACjE;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;iEAEiE;AACjE;EACE,aAAa;EACb,kBAAkB;EAClB,6DAA6D;EAC7D,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,wDAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,cAAc;EACd,kBAAkB;EAClB,8BAA8B;EAC9B,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,YAAY;AACd;;AAEA;;iEAEiE;AACjE;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,yCAAyC;EACzC,qDAAgC;AAClC;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,8BAA8B;EAC9B,6DAA6D;AAC/D;;AAEA;EACE,uCAAuC;EACvC,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,6DAA6D;EAC7D,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC;EACrC,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;iEAEiE;AACjE;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;iEAEiE;AACjE;EACE,gBAAgB;EAChB,aAAa;EACb,6DAA6D;EAC7D,kBAAkB;EAClB,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;iEAEiE;AACjE;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;EACd,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,SAAO;AACT;;AAEA;;iEAEiE;AACjE;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,8DAA0C;AAC5C;;AAEA;EACE;;IAEE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;iEAEiE;AACjE;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oDAAoD;EACpD,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;;iEAEiE;AACjE;EACE,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,qCAAqC;EACrC,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;;iEAEiE;AACjE;EACE,aAAa;EACb,QAAQ;EACR,cAAc;EACd,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,oCAAoC;EACpC,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;iEAEiE;AACjE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;iEAEiE;AACjE;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA,6CAA6C;AAC7C;EACE,aAAa;EACb;;;;;;uBAMqB,EAAE,kBAAkB;EACzC,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,gCAAgC;EAChC,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;AACrB;;AAEA;;;EAGE,uBAAuB;AACzB;;AAEA,uDAAuD;AACvD;EACE,cAAc;EACd,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,mDAAmD;AACnD;EACE,aAAa;EACb;;;;;;uBAMqB;EACrB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA,oDAAoD;AACpD;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kDAAkD;EAClD,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,uCAAuC;AACvC;EACE,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA,4CAA4C;AAC5C;;EAEE,wBAAwB;EACxB,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA,mDAAmD;AACnD;;EAEE,uBAAuB;AACzB;;AAEA;;iEAEiE;AACjE;EACE,gBAAgB;EAChB,cAAc;EACd,kDAAkD;EAClD,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;;iEAEiE;AACjE;;;EAGE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kDAAkD;EAClD,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf;;oBAEkB;AACpB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,oBAAoB;EACpB,eAAe;AACjB;;AAEA,oFAAoF;AACpF;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,yCAAyC;AACzC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,uCAAuC;AACvC;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,uDAAuD;AACzD;;AAEA;;iEAEiE;AACjE;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,0BAA0B;EAC1B,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,kDAAkD;EAClD,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,kDAAkD;EAClD,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,eAAe;EACf,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,kDAAkD;EAClD,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,kDAAkD;EAClD,cAAc;EACd,gBAAgB;AAClB;;AAEA;;iEAEiE;AACjE;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;;iEAEiE;AACjE;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;;iEAEiE;AACjE;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;;iEAEiE;AACjE;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;;iEAEiE;AACjE;EACE,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;AAC9B;AACA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,8BAA8B;AAChC;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;iEAEiE;AACjE;EACE,kBAAkB;EAClB,aAAa;EACb,6DAA6D;EAC7D,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;iEAEiE;AACjE;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;;iEAEiE;AACjE;EACE;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;;IAEE;;;;;;yBAMqB;IACrB,eAAe;EACjB;AACF;;AAEA;EACE,6DAA6D;EAC7D;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;IAC1B,aAAa;EACf;;EAEA;IACE,aAAa;IACb,gCAAgC;IAChC,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;IACX,cAAc;IACd,iCAAiC;IACjC,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,iBAAiB;IACjB,yBAAyB;IACzB,sBAAsB;IACtB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,gCAAgC;EAClC;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF","sourcesContent":["/* ============================================================\n   HEADER / TITLE\n   ============================================================ */\n.leadGenWrapper {\n  width: 100%;\n  margin: 0 auto;\n  min-height: 700px;\n}\n\n.headerSection {\n  text-align: center;\n  margin-bottom: 32px;\n  padding-bottom: 24px;\n  border-bottom: 2px solid #e9ecef;\n}\n\n.title {\n  font-size: 2rem;\n  font-weight: 700;\n  color: var(--dark-color, #2d3748);\n  margin-bottom: 12px;\n  letter-spacing: -0.5px;\n}\n\n.subtitle {\n  color: #6c757d;\n  font-size: 1rem;\n  line-height: 1.5;\n  margin-top: 8px;\n}\n\n/* ============================================================\n   HEADER ACTIONS\n   ============================================================ */\n.headerActions {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 16px;\n  flex-wrap: wrap;\n  margin-top: 12px;\n}\n\n.shortcutsToggleBtn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  background: #edf2f7;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  font-size: 12px;\n  cursor: pointer;\n  color: #4a5568;\n  transition: all 0.2s;\n}\n\n.shortcutsToggleBtn:hover {\n  background: #e2e8f0;\n}\n\n/* ============================================================\n   LOADING / ERROR STATES\n   ============================================================ */\n.loadingContainer {\n  padding: 40px;\n  text-align: center;\n  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);\n  border-radius: 12px;\n  max-width: 500px;\n  margin: 40px auto;\n}\n\n.loadingSpinner {\n  width: 50px;\n  height: 50px;\n  border: 3px solid #e9ecef;\n  border-top-color: #667eea;\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n  margin: 0 auto 20px;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.loadingTitle {\n  color: #495057;\n  margin-bottom: 16px;\n  font-size: 1.25rem;\n}\n\n.loadingText {\n  color: #6c757d;\n  margin: 8px 0;\n}\n\n.errorContainer {\n  padding: 16px 20px;\n  background: linear-gradient(135deg, #ffebee 0%, #ffcdd2 100%);\n  color: #c62828;\n  border-radius: 8px;\n  border-left: 4px solid #c62828;\n  margin: 20px;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.errorIcon {\n  font-size: 20px;\n  color: #e53e3e;\n  cursor: help;\n}\n\n/* ============================================================\n   FORMS SECTION\n   ============================================================ */\n.formsSection {\n  margin-top: 32px;\n}\n\n.sectionHeader {\n  margin-bottom: 24px;\n}\n\n.sectionTitle {\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: #495057;\n  margin-bottom: 8px;\n}\n\n.sectionSubtitle {\n  color: #6c757d;\n  font-size: 0.875rem;\n}\n\n.formsGrid {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.formCard {\n  border-radius: 12px;\n  padding: 24px;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  animation: slideIn 0.3s ease-out;\n}\n\n.formCard:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);\n}\n\n.formCardMapped {\n  border-left: 4px solid #28a745;\n  background: linear-gradient(135deg, #ffffff 0%, #f0f9f0 100%);\n}\n\n.formCardUnmapped {\n  background: var(--white-color, #ffffff);\n  border: 1px solid #e9ecef;\n  border-left: 4px solid #ff9800;\n}\n\n.formCardHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  padding-bottom: 16px;\n  border-bottom: 2px solid #e9ecef;\n}\n\n.formTitleSection {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.formTitle {\n  margin: 0;\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: #495057;\n}\n\n.badgeMapped {\n  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);\n  color: white;\n  padding: 4px 12px;\n  border-radius: 20px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  letter-spacing: 0.5px;\n}\n\n.badgeUnmapped {\n  background: linear-gradient(135deg, #ff9800 0%, #fb8c00 100%);\n  color: white;\n  padding: 4px 12px;\n  border-radius: 20px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  letter-spacing: 0.5px;\n}\n\n.badgeFieldsMapped {\n  background: linear-gradient(135deg, #805ad5 0%, #6b46c1 100%);\n  color: white;\n  padding: 4px 12px;\n  border-radius: 20px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  letter-spacing: 0.5px;\n}\n\n.formFieldsSection {\n  margin-bottom: 16px;\n}\n\n.formFieldsLabel {\n  font-weight: 600;\n  margin-bottom: 8px;\n  color: #495057;\n  font-size: 0.875rem;\n}\n\n.formFieldsList {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.fieldTag {\n  padding: 6px 12px;\n  background: linear-gradient(135deg, #e3f2fd 0%, #bbdef5 100%);\n  border-radius: 6px;\n  font-size: 0.813rem;\n  font-family: \"Courier New\", monospace;\n  color: #1976d2;\n  border: 1px solid #90caf9;\n}\n\n.requiredStar {\n  color: #dc3545;\n  margin-left: 3px;\n  font-weight: bold;\n}\n\n/* ============================================================\n   FORM CONFIG / SELECT\n   ============================================================ */\n.apiConfigSection {\n  margin-bottom: 16px;\n}\n\n.formLabel {\n  display: block;\n  font-weight: 600;\n  margin-bottom: 8px;\n  color: #495057;\n  font-size: 0.875rem;\n}\n\n.selectWrapper {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n}\n\n.selectIcon {\n  position: absolute;\n  right: 10px;\n  top: 40%;\n  transform: translateY(-50%);\n  pointer-events: none;\n  color: #666;\n}\n\n.selectInput {\n  width: 100%;\n  padding: 10px 12px;\n  border: 2px solid #e9ecef;\n  border-radius: 8px;\n  font-size: 0.875rem;\n  transition: all 0.3s ease;\n  background-color: white;\n  margin-bottom: 12px;\n}\n\n.selectInput:focus {\n  outline: none;\n  border-color: #667eea;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n.customSelect {\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  padding-right: 30px;\n  cursor: pointer;\n}\n\n.customSelect::-ms-expand {\n  display: none;\n}\n\n.mapButton {\n  padding: 10px 20px;\n  background: var(--saveHover, #48bb78);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 0.875rem;\n  font-weight: 600;\n  transition: all 0.3s ease;\n  width: 100%;\n}\n\n.mapButton:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(76, 175, 80, 0.3);\n}\n\n.mapFieldsBtn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  margin-left: 12px;\n  padding: 4px 12px;\n  background: #4a90d9;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  font-size: 12px;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.mapFieldsBtn:hover {\n  background: #357abd;\n}\n\n/* ============================================================\n   MAPPED CONFIG INFO\n   ============================================================ */\n.mappedConfigInfo {\n  margin-top: 16px;\n  padding: 16px;\n  background: linear-gradient(135deg, #f5f5f5 0%, #e9ecef 100%);\n  border-radius: 8px;\n  border-left: 3px solid #4caf50;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.mappedConfigInfo strong {\n  background-color: transparent;\n  color: #999;\n  margin-bottom: 15px;\n  border-radius: 12px;\n  word-wrap: break-word;\n}\n\n.configDetails {\n  margin-top: 12px;\n}\n\n.configRow {\n  margin: 8px 0;\n  font-size: 0.875rem;\n}\n\n.configLabel {\n  font-weight: 600;\n  color: #495057;\n  margin-right: 8px;\n}\n\n.configValue {\n  color: #6c757d;\n  font-family: \"Courier New\", monospace;\n}\n\n.configSummary {\n  cursor: pointer;\n  color: #667eea;\n  font-weight: 600;\n  font-size: 0.875rem;\n  margin-top: 8px;\n}\n\n.configPre {\n  font-size: 11px;\n  white-space: pre-wrap;\n  background-color: #ffffff;\n  padding: 12px;\n  border-radius: 6px;\n  margin-top: 8px;\n  border: 1px solid #dee2e6;\n  overflow-x: auto;\n}\n\n/* ============================================================\n   MODAL SHELL\n   ============================================================ */\n.modalOverlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.modalContent {\n  background: white;\n  border-radius: 12px;\n  max-width: 1100px;\n  width: 95%;\n  max-height: 88vh;\n  overflow: hidden;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n  display: flex;\n  flex-direction: column;\n}\n\n.modalHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 18px 24px;\n  border-bottom: 1px solid #e2e8f0;\n  flex-shrink: 0;\n}\n\n.modalHeader h3 {\n  margin: 0;\n  color: #2d3748;\n  font-size: 18px;\n}\n\n.modalHeaderActions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.modalCloseBtn {\n  background: none;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  color: #a0aec0;\n  padding: 0 8px;\n  line-height: 1;\n  background: none;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  color: #666;\n  padding: 4px 8px;\n  border-radius: 4px;\n}\n\n.modalCloseBtn:hover {\n  background: #f0f0f0;\n  color: #333;\n}\n\n.modalBody {\n  padding: 24px;\n  overflow-y: auto;\n  flex: 1;\n}\n\n/* ============================================================\n   MODAL HEADER ACTIONS\n   ============================================================ */\n.unsavedIndicator {\n  font-size: 12px;\n  color: #e53e3e;\n  font-weight: 500;\n  animation: pulse 1.5s ease-in-out infinite;\n}\n\n@keyframes pulse {\n  0%,\n  100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.5;\n  }\n}\n\n.clearAllBtn {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 12px;\n  background: transparent;\n  color: #4299e1;\n  border: none;\n  border-radius: 4px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: all 0.2s;\n  border: 1px solid #4299e1;\n}\n\n.clearAllBtn:hover {\n  background: #b4ddff;\n}\n\n/* ============================================================\n   MODAL INFO / CONFIG BLOCK\n   ============================================================ */\n.mappingInfo {\n  color: #4a5568;\n  margin-bottom: 16px;\n  font-size: 14px;\n}\n\n.selectedConfigInfo {\n  background: #f7fafc;\n  padding: 12px 16px;\n  border-radius: 6px;\n  margin-bottom: 20px;\n  font-size: 14px;\n  color: #2d3748;\n}\n\n.configUrl {\n  margin-bottom: 6px;\n  word-break: break-word;\n}\n\n.configStructure {\n  margin-top: 16px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n\n.structureLabel {\n  font-size: 13px;\n  color: #4a5568;\n  font-weight: 500;\n}\n\n.structureBadge {\n  font-size: 11px;\n  padding: 6px 10px;\n  border-radius: 40px;\n  font-weight: 500;\n  white-space: nowrap;\n}\n\n.structureBadge.path {\n  background: #fef3c7;\n  color: #92400e;\n}\n.structureBadge.query {\n  background: #dbeafe;\n  color: #1e40af;\n}\n.structureBadge.payload {\n  background: #d1fae5;\n  color: #065f46;\n}\n\n.mappingProgress {\n  margin-top: 12px;\n  font-size: 13px;\n  color: #4a5568;\n}\n\n.progressBar {\n  margin-top: 6px;\n  height: 8px;\n  background: #e2e8f0;\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.progressFill {\n  height: 100%;\n  background: linear-gradient(90deg, #48bb78, #38a169);\n  transition: width 0.3s ease;\n  border-radius: 4px;\n}\n\n/* ============================================================\n   STRICT AUTH / CHECKBOX\n   ============================================================ */\n.strictAuthSection {\n  margin-bottom: 16px;\n  padding: 12px;\n  background-color: #f8f9fa;\n  border-radius: 6px;\n}\n\n.checkboxLabel {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  user-select: none;\n  font-size: 13px;\n  color: #2d3748;\n}\n\n.checkbox {\n  width: 18px;\n  height: 18px;\n  cursor: pointer;\n  accent-color: var(--saveBtn, #4a90d9);\n  color: var(--white-color, #ffffff);\n}\n\n.helperText {\n  color: #6c757d;\n  font-size: 0.75rem;\n}\n\n/* ============================================================\n   TABS\n   ============================================================ */\n.tabs {\n  display: flex;\n  gap: 4px;\n  margin: 16px 0;\n  border-bottom: 2px solid #e2e8f0;\n  flex-wrap: wrap;\n}\n\n.tab {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 16px;\n  background: none;\n  border: none;\n  border-bottom: 2px solid transparent;\n  cursor: pointer;\n  color: #4a5568;\n  font-weight: 500;\n  transition: all 0.2s;\n  margin-bottom: -2px;\n}\n\n.tab:hover {\n  color: #2d3748;\n}\n\n.tabActive {\n  color: #4a90d9;\n  border-bottom-color: #4a90d9;\n}\n\n.tabDisabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  color: #a0aec0;\n}\n\n.tabDisabled:hover {\n  color: #a0aec0;\n}\n\n.tabBadge {\n  display: inline-flex;\n  align-items: center;\n  gap: 2px;\n  margin-left: 6px;\n  background: #edf2f7;\n  padding: 1px 8px;\n  border-radius: 10px;\n  font-size: 11px;\n  color: #4a5568;\n}\n\n.tabActive .tabBadge {\n  background: #bee3f8;\n  color: #2b6cb0;\n}\n\n.requiredAsterisk {\n  color: #e53e3e;\n  font-weight: bold;\n  font-size: 14px;\n  margin-left: 1px;\n}\n\n/* ============================================================\n   AUTO-MAP BUTTON\n   ============================================================ */\n.autoMapBtn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 14px;\n  background: #e9d8fd;\n  color: #553c9a;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 13px;\n  margin-bottom: 12px;\n  transition: background 0.2s;\n}\n\n.autoMapBtn:hover {\n  background: #d6bcfa;\n}\n\n/* ============================================================\n   MAPPING TABLE\n   ============================================================ */\n.mappingTable {\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  overflow: hidden;\n  background: #ffffff;\n  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04);\n}\n\n/* ---------- Header (6 columns) ---------- */\n.mappingHeader {\n  display: grid;\n  grid-template-columns:\n    minmax(180px, 1.4fr) /* API Parameter */\n    32px /* → arrow       */\n    minmax(160px, 1.6fr) /* Form Field    */\n    minmax(110px, 0.9fr) /* Convert To    */\n    minmax(90px, 0.7fr) /* Location      */\n    minmax(60px, 0.4fr); /* Template      */\n  align-items: center;\n  column-gap: 10px;\n  padding: 12px 16px;\n  background: #f7fafc;\n  font-weight: 700;\n  font-size: 11.5px;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #718096;\n  border-bottom: 1px solid #e2e8f0;\n  position: sticky;\n  top: 0;\n  z-index: 1;\n}\n\n.mappingHeader .mappingColumn {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: flex;\n  align-items: center;\n}\n\n.mappingHeader .mappingColumn:nth-child(2),\n.mappingHeader .mappingColumn:nth-child(5),\n.mappingHeader .mappingColumn:nth-child(6) {\n  justify-content: center;\n}\n\n/* ---------- Row wrapper: block, not grid ---------- */\n.mappingRow {\n  display: block;\n  padding: 12px 16px;\n  border-bottom: 1px solid #f0f0f0;\n  font-size: 13px;\n  transition: background 0.15s ease;\n}\n\n.mappingRow:last-child {\n  border-bottom: none;\n}\n\n.mappingRow:hover {\n  background: #fafbfc;\n}\n\n.mappingRowHasTemplate {\n  background: #fdfcff;\n}\n\n/* ---------- Row main line: 6 columns ---------- */\n.mappingRowMain {\n  display: grid;\n  grid-template-columns:\n    minmax(180px, 1.4fr)\n    32px\n    minmax(160px, 1.6fr)\n    minmax(110px, 0.9fr)\n    minmax(90px, 0.7fr)\n    minmax(60px, 0.4fr);\n  align-items: center;\n  column-gap: 10px;\n}\n\n.mappingColumn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n  overflow: hidden;\n  font-size: 13px;\n  color: #2d3748;\n  line-height: 1.35;\n}\n\n/* ---------- Col 1: param header block ---------- */\n.mappingRowMain .mappingColumn:nth-child(1) {\n  display: block;\n  min-width: 0;\n}\n\n.paramHeader {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex-wrap: wrap;\n  min-width: 0;\n}\n\n.mappingRowMain .mappingColumn:nth-child(1) .fieldName {\n  font-weight: 600;\n  color: #2d3748;\n  font-family: \"SF Mono\", Menlo, Consolas, monospace;\n  font-size: 12.5px;\n  word-break: break-word;\n}\n\n.fieldType {\n  font-size: 10.5px;\n  color: #718096;\n  white-space: nowrap;\n  text-transform: uppercase;\n  letter-spacing: 0.02em;\n}\n\n.compatBadge {\n  display: inline-flex;\n  align-items: center;\n  font-size: 10px;\n  font-weight: 600;\n  color: white;\n  padding: 1px 6px;\n  border-radius: 8px;\n  white-space: nowrap;\n  letter-spacing: 0.02em;\n}\n\n.compatReason {\n  font-size: 10.5px;\n  color: #a0aec0;\n  margin-top: 3px;\n  line-height: 1.3;\n}\n\n/* ---------- Col 2: arrow ---------- */\n.mappingRowMain .mappingColumn:nth-child(2) {\n  justify-content: center;\n  color: #cbd5e0;\n  font-size: 14px;\n  user-select: none;\n}\n\n.mappingArrow {\n  font-size: 12px;\n}\n\n/* ---------- Cols 3-4: selects ---------- */\n.mappingRowMain .mappingColumn:nth-child(3),\n.mappingRowMain .mappingColumn:nth-child(4) {\n  justify-content: stretch;\n  min-width: 0;\n}\n\n.mappingRowMain .mappingColumn:nth-child(3) > *,\n.mappingRowMain .mappingColumn:nth-child(4) > * {\n  width: 100%;\n  min-width: 0;\n}\n\n/* ---------- Cols 5-6: badge + toggle ---------- */\n.mappingRowMain .mappingColumn:nth-child(5),\n.mappingRowMain .mappingColumn:nth-child(6) {\n  justify-content: center;\n}\n\n/* ============================================================\n   FIELD NAME / TYPE\n   ============================================================ */\n.fieldName {\n  font-weight: 600;\n  color: #2d3748;\n  font-family: \"SF Mono\", Menlo, Consolas, monospace;\n  font-size: 12.5px;\n  word-break: break-word;\n}\n\n/* ============================================================\n   MAPPING SELECT / INPUT\n   ============================================================ */\n.mappingSelect,\n.conversionSelect,\n.mappingInput {\n  width: 100%;\n  min-width: 0;\n  padding: 6px 26px 6px 8px;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  font-size: 12px;\n  font-family: \"SF Mono\", Menlo, Consolas, monospace;\n  background: #fff;\n  color: #2d3748;\n  appearance: none;\n  cursor: pointer;\n  transition:\n    border-color 0.15s,\n    box-shadow 0.15s;\n}\n\n.mappingSelect:focus,\n.mappingInput:focus {\n  outline: none;\n  border-color: #4a90d9;\n  box-shadow: 0 0 0 3px rgba(74, 144, 217, 0.15);\n}\n\n.selectWrapperSmall {\n  position: relative;\n  width: 100%;\n  min-width: 0;\n  flex: 1;\n}\n\n.selectIconSmall {\n  position: absolute;\n  right: 8px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #a0aec0;\n  pointer-events: none;\n  font-size: 10px;\n}\n\n/* ---------- Location-coloured selects (optional, kept for future use) ---------- */\n.mappingSelect.pathParam {\n  border-color: #f59e0b;\n}\n.mappingSelect.pathParam:focus {\n  border-color: #f59e0b;\n  box-shadow: 0 0 0 3px rgba(245, 158, 11, 0.2);\n}\n.mappingSelect.queryParam {\n  border-color: #3b82f6;\n}\n.mappingSelect.queryParam:focus {\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.2);\n}\n.mappingSelect.payloadParam {\n  border-color: #10b981;\n}\n.mappingSelect.payloadParam:focus {\n  border-color: #10b981;\n  box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.2);\n}\n\n.mappingInput.pathParam {\n  border-color: #f59e0b;\n}\n.mappingInput.pathParam:focus {\n  border-color: #f59e0b;\n  box-shadow: 0 0 0 3px rgba(245, 158, 11, 0.2);\n}\n.mappingInput.queryParam {\n  border-color: #3b82f6;\n}\n.mappingInput.queryParam:focus {\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.2);\n}\n.mappingInput.payloadParam {\n  border-color: #10b981;\n}\n.mappingInput.payloadParam:focus {\n  border-color: #10b981;\n  box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.2);\n}\n\n/* ---------- Location badge ---------- */\n.locationBadge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 10.5px;\n  padding: 3px 8px;\n  border-radius: 10px;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n  white-space: nowrap;\n}\n\n.locationBadge.path {\n  background: #fef3c7;\n  color: #92400e;\n}\n.locationBadge.query {\n  background: #dbeafe;\n  color: #1e40af;\n}\n.locationBadge.payload {\n  background: #d1fae5;\n  color: #065f46;\n}\n\n/* ---------- Error select ---------- */\n.mappingSelectError {\n  border-color: #e53e3e !important;\n}\n\n.mappingSelectError:focus {\n  border-color: #e53e3e !important;\n  box-shadow: 0 0 0 3px rgba(229, 62, 62, 0.2) !important;\n}\n\n/* ============================================================\n   TEMPLATE TOGGLE + EDITOR\n   ============================================================ */\n.templateToggleBtn {\n  padding: 5px 10px;\n  font-size: 12px;\n  border-radius: 6px;\n  border: 1px solid #e2e8f0;\n  background-color: white;\n  color: #4a5568;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: all 0.15s ease;\n  font-family: system-ui;\n  line-height: 1.2;\n}\n\n.templateToggleBtn:hover {\n  background-color: #edf2f7;\n  border-color: #cbd5e0;\n}\n\n.templateToggleBtnActive {\n  border-color: #9f7aea;\n  background-color: #faf5ff;\n  color: #6b46c1;\n}\n\n.templateToggleBtnActive:hover {\n  background-color: #f3e8ff;\n}\n\n.templateEditor {\n  margin-top: 12px;\n  padding: 12px 14px;\n  background-color: #fafafa;\n  border-radius: 8px;\n  border: 1px solid #e9e3f5;\n}\n\n.templateEditorHint {\n  font-size: 11.5px;\n  color: #4a5568;\n  margin-bottom: 8px;\n  line-height: 1.5;\n}\n\n.templateEditorHint code {\n  background-color: #edf2f7;\n  padding: 1px 5px;\n  border-radius: 3px;\n  font-family: \"SF Mono\", Menlo, Consolas, monospace;\n  font-size: 11px;\n}\n\n.templateTextarea {\n  width: 100%;\n  box-sizing: border-box;\n  font-family: \"SF Mono\", Menlo, Consolas, monospace;\n  font-size: 12px;\n  padding: 8px 10px;\n  border-radius: 6px;\n  border: 1px solid #cbd5e0;\n  background-color: white;\n  resize: vertical;\n  line-height: 1.5;\n  color: #2d3748;\n}\n\n.templateTextarea:focus {\n  outline: none;\n  border-color: #9f7aea;\n  box-shadow: 0 0 0 3px rgba(159, 122, 234, 0.15);\n}\n\n.templateFieldChips {\n  margin-top: 8px;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 4px;\n}\n\n.templateFieldChipsLabel {\n  font-size: 10.5px;\n  color: #718096;\n  margin-right: 4px;\n  font-weight: 500;\n}\n\n.templateFieldChip {\n  padding: 2px 8px;\n  font-size: 10.5px;\n  border-radius: 10px;\n  border: 1px solid #cbd5e0;\n  background-color: white;\n  color: #4a5568;\n  cursor: pointer;\n  font-family: \"SF Mono\", Menlo, Consolas, monospace;\n  transition: all 0.15s ease;\n  line-height: 1.4;\n}\n\n.templateFieldChip:hover {\n  background-color: #faf5ff;\n  border-color: #9f7aea;\n  color: #6b46c1;\n}\n\n.templatePreview {\n  margin-top: 10px;\n  padding: 8px 12px;\n  border-radius: 6px;\n  font-size: 11.5px;\n}\n\n.templatePreviewJson {\n  background-color: #f0fff4;\n  border: 1px solid #9ae6b4;\n}\n\n.templatePreviewString {\n  background-color: #ebf8ff;\n  border: 1px solid #90cdf4;\n}\n\n.templatePreviewEmpty {\n  background-color: #fffaf0;\n  border: 1px solid #f6ad55;\n}\n\n.templatePreviewLabel {\n  font-weight: 600;\n  margin-bottom: 4px;\n  font-size: 11px;\n}\n\n.templatePreviewJson .templatePreviewLabel {\n  color: #22543d;\n}\n\n.templatePreviewString .templatePreviewLabel {\n  color: #2a4365;\n}\n\n.templatePreviewEmpty .templatePreviewLabel {\n  color: #744210;\n}\n\n.templatePreviewValue {\n  font-size: 11.5px;\n  word-break: break-all;\n  white-space: pre-wrap;\n  color: #2d3748;\n  font-family: \"SF Mono\", Menlo, Consolas, monospace;\n  display: block;\n  line-height: 1.5;\n}\n\n/* ============================================================\n   STRUCTURE SECTIONS / UNUSED FIELDS\n   ============================================================ */\n.structureSection {\n  margin-top: 12px;\n  padding: 12px 16px;\n  background: #f7fafc;\n  border-radius: 6px;\n}\n\n.structureSection h4 {\n  margin: 0 0 4px 0;\n  font-size: 14px;\n  color: #2d3748;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.structureSection p {\n  margin: 0 0 8px 0;\n  font-size: 13px;\n  color: #4a5568;\n}\n\n.apiStructureDetails {\n  margin-top: 16px;\n  padding: 12px 16px;\n  background: #f7fafc;\n  border-radius: 6px;\n}\n\n.paramList {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.paramTag {\n  font-size: 12px;\n  padding: 3px 10px;\n  border-radius: 12px;\n  font-family: monospace;\n  background: #e2e8f0;\n  color: #2d3748;\n}\n\n.paramTag.path {\n  background: #fef3c7;\n  color: #92400e;\n}\n.paramTag.query {\n  background: #dbeafe;\n  color: #1e40af;\n}\n.paramTag.payload {\n  background: #d1fae5;\n  color: #065f46;\n}\n\n.paramTag.static {\n  background: #edf2f7;\n  color: #4a5568;\n  opacity: 0.7;\n  text-decoration: line-through;\n}\n\n.staticBadge {\n  font-size: 9px;\n  background: #e2e8f0;\n  color: #4a5568;\n  padding: 1px 6px;\n  border-radius: 8px;\n  margin-left: 4px;\n  font-family: system-ui;\n  text-decoration: none;\n}\n\n/* ============================================================\n   VALIDATION\n   ============================================================ */\n.validationSummary {\n  margin-top: 12px;\n  padding: 12px 16px;\n  background: #fff5f5;\n  border: 1px solid #feb2b2;\n  border-radius: 6px;\n  color: #9b2c2c;\n  font-size: 13px;\n}\n\n.validationSummary ul {\n  margin: 4px 0 0 20px;\n  padding: 0;\n}\n\n.validationSummary li {\n  margin: 2px 0;\n}\n\n/* ============================================================\n   MODAL ACTIONS\n   ============================================================ */\n.modalActions {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n  margin-top: 20px;\n  padding-top: 16px;\n  border-top: 1px solid #e2e8f0;\n}\n\n.modalActionsLeft {\n  display: flex;\n  align-items: center;\n}\n\n.modalActionsRight {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.shortcutHint {\n  font-size: 12px;\n  color: #a0aec0;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.cancelBtn {\n  padding: 8px 20px;\n  background: #edf2f7;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  color: #4a5568;\n}\n\n.cancelBtn:hover {\n  background: #e2e8f0;\n}\n\n.saveMappingsBtn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 24px;\n  background: #4a90d9;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-weight: 500;\n}\n\n.saveMappingsBtn:hover {\n  background: #357abd;\n}\n\n.saveMappingsBtn:disabled {\n  background: #cbd5e0;\n  cursor: not-allowed;\n}\n\n.saveMappingsBtn svg {\n  font-size: 14px;\n}\n\n/* ============================================================\n   KEYBOARD SHORTCUTS MODAL\n   ============================================================ */\n.shortcutsOverlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 2000;\n}\n\n.shortcutsContent {\n  background: white;\n  border-radius: 12px;\n  max-width: 400px;\n  width: 90%;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n}\n\n.shortcutsHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 24px;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.shortcutsHeader h3 {\n  margin: 0;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 16px;\n  color: #2d3748;\n}\n\n.shortcutsCloseBtn {\n  background: none;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  color: #a0aec0;\n}\n\n.shortcutsCloseBtn:hover {\n  color: #4a5568;\n}\n\n.shortcutsBody {\n  padding: 20px 24px;\n}\n\n.shortcutRow {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px 0;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.shortcutRow:last-child {\n  border-bottom: none;\n}\n\n.shortcutKey {\n  font-family: monospace;\n  font-weight: 600;\n  color: #2d3748;\n  background: #edf2f7;\n  padding: 2px 10px;\n  border-radius: 4px;\n  font-size: 13px;\n}\n\n.shortcutDesc {\n  color: #4a5568;\n  font-size: 13px;\n}\n\n/* ============================================================\n   EDIT / FIELD SUMMARY / DATA SOURCE\n   ============================================================ */\n.configSelectedIndicator {\n  display: inline-block;\n  margin-left: 12px;\n  color: #48bb78;\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.editMappingBtn {\n  padding: 8px 20px;\n  background: var(--editBtn);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 0.875rem;\n  font-weight: 500;\n  transition: all 0.2s ease;\n}\n\n.editMappingBtn:hover {\n  background: var(--editHover);\n}\n.deleteMappingBtn {\n  padding: 8px 20px;\n  background: var(--deleteBtn);\n  color: var(--white-color);\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 0.875rem;\n  font-weight: 500;\n  transition: all 0.2s ease;\n}\n.deleteMappingBtn:hover {\n  background: var(--deleteHover);\n}\n.fieldMappingsSummary {\n  margin-top: 8px;\n  padding: 8px 12px;\n  background: #f7fafc;\n  border-radius: 4px;\n}\n\n.mappingTags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  margin-top: 4px;\n}\n\n.mappingTag {\n  background: #e9d8fd;\n  color: #553c9a;\n  padding: 2px 8px;\n  border-radius: 10px;\n  font-size: 11px;\n  font-family: monospace;\n}\n\n.dataSourceIndicator {\n  margin-top: 12px;\n  padding: 8px 16px;\n  background: #f0f4ff;\n  border-radius: 6px;\n  font-size: 14px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.dataSourceLabel {\n  font-weight: 600;\n  color: #4a5568;\n}\n\n.dataSourceValue {\n  color: #2b6cb0;\n  font-weight: 500;\n}\n\n.badgeNewTable {\n  font-size: 10px;\n  padding: 2px 8px;\n  border-radius: 12px;\n  background: #48bb78;\n  color: white;\n  font-weight: 600;\n  margin-left: 8px;\n}\n\n.badgeLegacy {\n  font-size: 10px;\n  padding: 2px 8px;\n  border-radius: 12px;\n  background: #a0aec0;\n  color: white;\n  font-weight: 600;\n  margin-left: 8px;\n}\n\n/* ============================================================\n   EMPTY STATE\n   ============================================================ */\n.emptyState {\n  text-align: center;\n  padding: 40px;\n  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);\n  border-radius: 12px;\n  color: #6c757d;\n}\n\n/* ============================================================\n   ANIMATIONS\n   ============================================================ */\n@keyframes slideIn {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* ============================================================\n   RESPONSIVE\n   ============================================================ */\n@media (max-width: 768px) {\n  .leadGenWrapper {\n    padding: 16px;\n  }\n\n  .title {\n    font-size: 1.5rem;\n  }\n\n  .formCard {\n    padding: 16px;\n  }\n\n  .formTitleSection {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .fieldTag {\n    font-size: 0.75rem;\n  }\n\n  .modalActions {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .modalActionsRight {\n    justify-content: flex-end;\n  }\n}\n\n@media (max-width: 900px) {\n  .mappingHeader,\n  .mappingRowMain {\n    grid-template-columns:\n      minmax(150px, 1.4fr)\n      28px\n      minmax(140px, 1.5fr)\n      minmax(100px, 0.9fr)\n      minmax(80px, 0.7fr)\n      minmax(56px, 0.4fr);\n    column-gap: 8px;\n  }\n}\n\n@media (max-width: 720px) {\n  /* ---------- Stack the mapping table into cards ---------- */\n  .mappingHeader {\n    display: none;\n  }\n\n  .mappingRowMain {\n    grid-template-columns: 1fr;\n    row-gap: 10px;\n  }\n\n  .mappingRowMain .mappingColumn {\n    display: grid;\n    grid-template-columns: 110px 1fr;\n    align-items: center;\n    column-gap: 10px;\n    width: 100%;\n    padding: 4px 0;\n    border-bottom: 1px dashed #edf2f7;\n    overflow: visible;\n  }\n\n  .mappingRowMain .mappingColumn:last-child {\n    border-bottom: none;\n  }\n\n  .mappingRowMain .mappingColumn::before {\n    content: attr(data-label);\n    font-size: 10.5px;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n    color: #a0aec0;\n    font-weight: 700;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  .mappingRowMain .mappingColumn:nth-child(2) {\n    display: none;\n  }\n\n  .mappingRowMain .mappingColumn:nth-child(1) {\n    display: block;\n    padding-bottom: 8px;\n    margin-bottom: 4px;\n    border-bottom: 1px solid #e2e8f0;\n  }\n\n  .mappingRowMain .mappingColumn:nth-child(1)::before {\n    display: none;\n  }\n}\n\n@media (max-width: 480px) {\n  .leadGenWrapper {\n    padding: 0;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"leadGenWrapper": `LeadGenIndex_leadGenWrapper__oie2L`,
	"headerSection": `LeadGenIndex_headerSection__St1jk`,
	"title": `LeadGenIndex_title__RAilZ`,
	"subtitle": `LeadGenIndex_subtitle__ZOOKW`,
	"headerActions": `LeadGenIndex_headerActions__izEvp`,
	"shortcutsToggleBtn": `LeadGenIndex_shortcutsToggleBtn__ogtUw`,
	"loadingContainer": `LeadGenIndex_loadingContainer__3VQSS`,
	"loadingSpinner": `LeadGenIndex_loadingSpinner__DC-v1`,
	"spin": `LeadGenIndex_spin__meOOi`,
	"loadingTitle": `LeadGenIndex_loadingTitle__rDCVR`,
	"loadingText": `LeadGenIndex_loadingText__wwcTb`,
	"errorContainer": `LeadGenIndex_errorContainer__lvBOi`,
	"errorIcon": `LeadGenIndex_errorIcon__uc3xZ`,
	"formsSection": `LeadGenIndex_formsSection__Q3tJG`,
	"sectionHeader": `LeadGenIndex_sectionHeader__sonYP`,
	"sectionTitle": `LeadGenIndex_sectionTitle__AM4GH`,
	"sectionSubtitle": `LeadGenIndex_sectionSubtitle__2PDXx`,
	"formsGrid": `LeadGenIndex_formsGrid__wQ3uQ`,
	"formCard": `LeadGenIndex_formCard__CuRvT`,
	"slideIn": `LeadGenIndex_slideIn__+D8ch`,
	"formCardMapped": `LeadGenIndex_formCardMapped__PN7wU`,
	"formCardUnmapped": `LeadGenIndex_formCardUnmapped__Wajja`,
	"formCardHeader": `LeadGenIndex_formCardHeader__xdhak`,
	"formTitleSection": `LeadGenIndex_formTitleSection__eo7CC`,
	"formTitle": `LeadGenIndex_formTitle__mF3vd`,
	"badgeMapped": `LeadGenIndex_badgeMapped__dS6Kq`,
	"badgeUnmapped": `LeadGenIndex_badgeUnmapped__Dfv46`,
	"badgeFieldsMapped": `LeadGenIndex_badgeFieldsMapped__NVeQu`,
	"formFieldsSection": `LeadGenIndex_formFieldsSection__FvJn7`,
	"formFieldsLabel": `LeadGenIndex_formFieldsLabel__i7d0E`,
	"formFieldsList": `LeadGenIndex_formFieldsList__yI-p5`,
	"fieldTag": `LeadGenIndex_fieldTag__zvoqq`,
	"requiredStar": `LeadGenIndex_requiredStar__-A5eX`,
	"apiConfigSection": `LeadGenIndex_apiConfigSection__zJGfi`,
	"formLabel": `LeadGenIndex_formLabel__Kr04L`,
	"selectWrapper": `LeadGenIndex_selectWrapper__1rNOR`,
	"selectIcon": `LeadGenIndex_selectIcon__vR7Le`,
	"selectInput": `LeadGenIndex_selectInput__lQWny`,
	"customSelect": `LeadGenIndex_customSelect__RGGEu`,
	"mapButton": `LeadGenIndex_mapButton__-kz-g`,
	"mapFieldsBtn": `LeadGenIndex_mapFieldsBtn__-Dn+x`,
	"mappedConfigInfo": `LeadGenIndex_mappedConfigInfo__V4izK`,
	"configDetails": `LeadGenIndex_configDetails__dvF-Q`,
	"configRow": `LeadGenIndex_configRow__bBQ7b`,
	"configLabel": `LeadGenIndex_configLabel__9ihuW`,
	"configValue": `LeadGenIndex_configValue__A12T7`,
	"configSummary": `LeadGenIndex_configSummary__UjfeE`,
	"configPre": `LeadGenIndex_configPre__xoRW2`,
	"modalOverlay": `LeadGenIndex_modalOverlay__K83I6`,
	"modalContent": `LeadGenIndex_modalContent__vtQ7j`,
	"modalHeader": `LeadGenIndex_modalHeader__1mFDP`,
	"modalHeaderActions": `LeadGenIndex_modalHeaderActions__rJ+L6`,
	"modalCloseBtn": `LeadGenIndex_modalCloseBtn__p3uWM`,
	"modalBody": `LeadGenIndex_modalBody__vRMOS`,
	"unsavedIndicator": `LeadGenIndex_unsavedIndicator__3+rQq`,
	"pulse": `LeadGenIndex_pulse__Lg7j6`,
	"clearAllBtn": `LeadGenIndex_clearAllBtn__wMvtH`,
	"mappingInfo": `LeadGenIndex_mappingInfo__LDKDc`,
	"selectedConfigInfo": `LeadGenIndex_selectedConfigInfo__W5E7P`,
	"configUrl": `LeadGenIndex_configUrl__Zof6c`,
	"configStructure": `LeadGenIndex_configStructure__SxFQh`,
	"structureLabel": `LeadGenIndex_structureLabel__yYadr`,
	"structureBadge": `LeadGenIndex_structureBadge__HCvnx`,
	"path": `LeadGenIndex_path__I6+8O`,
	"query": `LeadGenIndex_query__PzCOs`,
	"payload": `LeadGenIndex_payload__bItNO`,
	"mappingProgress": `LeadGenIndex_mappingProgress__rZNFc`,
	"progressBar": `LeadGenIndex_progressBar__HHYs2`,
	"progressFill": `LeadGenIndex_progressFill__Fyzw1`,
	"strictAuthSection": `LeadGenIndex_strictAuthSection__wt-gD`,
	"checkboxLabel": `LeadGenIndex_checkboxLabel__R3bLO`,
	"checkbox": `LeadGenIndex_checkbox__3DSI3`,
	"helperText": `LeadGenIndex_helperText__ZaPRp`,
	"tabs": `LeadGenIndex_tabs__X8xHJ`,
	"tab": `LeadGenIndex_tab__D94Ge`,
	"tabActive": `LeadGenIndex_tabActive__wZOsW`,
	"tabDisabled": `LeadGenIndex_tabDisabled__W8HGi`,
	"tabBadge": `LeadGenIndex_tabBadge__7SKwU`,
	"requiredAsterisk": `LeadGenIndex_requiredAsterisk__wRh3-`,
	"autoMapBtn": `LeadGenIndex_autoMapBtn__jHDgN`,
	"mappingTable": `LeadGenIndex_mappingTable__e48IV`,
	"mappingHeader": `LeadGenIndex_mappingHeader__qkaM7`,
	"mappingColumn": `LeadGenIndex_mappingColumn__+OXNb`,
	"mappingRow": `LeadGenIndex_mappingRow__UjMb7`,
	"mappingRowHasTemplate": `LeadGenIndex_mappingRowHasTemplate__EuJJr`,
	"mappingRowMain": `LeadGenIndex_mappingRowMain__PiGYB`,
	"paramHeader": `LeadGenIndex_paramHeader__PqGJL`,
	"fieldName": `LeadGenIndex_fieldName__ymrBV`,
	"fieldType": `LeadGenIndex_fieldType__cUSgB`,
	"compatBadge": `LeadGenIndex_compatBadge__-K9Qs`,
	"compatReason": `LeadGenIndex_compatReason__OSCc9`,
	"mappingArrow": `LeadGenIndex_mappingArrow__PaUS6`,
	"mappingSelect": `LeadGenIndex_mappingSelect__BQnDq`,
	"conversionSelect": `LeadGenIndex_conversionSelect__x1Xc+`,
	"mappingInput": `LeadGenIndex_mappingInput__jYMG0`,
	"selectWrapperSmall": `LeadGenIndex_selectWrapperSmall__UASJV`,
	"selectIconSmall": `LeadGenIndex_selectIconSmall__EW40i`,
	"pathParam": `LeadGenIndex_pathParam__nRA2r`,
	"queryParam": `LeadGenIndex_queryParam__bkmbZ`,
	"payloadParam": `LeadGenIndex_payloadParam__-5EEx`,
	"locationBadge": `LeadGenIndex_locationBadge__L1fCw`,
	"mappingSelectError": `LeadGenIndex_mappingSelectError__3fBlS`,
	"templateToggleBtn": `LeadGenIndex_templateToggleBtn__igihW`,
	"templateToggleBtnActive": `LeadGenIndex_templateToggleBtnActive__LMAh8`,
	"templateEditor": `LeadGenIndex_templateEditor__YJsu2`,
	"templateEditorHint": `LeadGenIndex_templateEditorHint__ZBFBC`,
	"templateTextarea": `LeadGenIndex_templateTextarea__w+FTI`,
	"templateFieldChips": `LeadGenIndex_templateFieldChips__TaOob`,
	"templateFieldChipsLabel": `LeadGenIndex_templateFieldChipsLabel__na1tv`,
	"templateFieldChip": `LeadGenIndex_templateFieldChip__aRFMZ`,
	"templatePreview": `LeadGenIndex_templatePreview__-7UgV`,
	"templatePreviewJson": `LeadGenIndex_templatePreviewJson__y6JTU`,
	"templatePreviewString": `LeadGenIndex_templatePreviewString__UTlp8`,
	"templatePreviewEmpty": `LeadGenIndex_templatePreviewEmpty__mg3ju`,
	"templatePreviewLabel": `LeadGenIndex_templatePreviewLabel__6CdJj`,
	"templatePreviewValue": `LeadGenIndex_templatePreviewValue__-Bv1B`,
	"structureSection": `LeadGenIndex_structureSection__wloDi`,
	"apiStructureDetails": `LeadGenIndex_apiStructureDetails__qdxPN`,
	"paramList": `LeadGenIndex_paramList__owWMv`,
	"paramTag": `LeadGenIndex_paramTag__pnhNQ`,
	"static": `LeadGenIndex_static__uTKb9`,
	"staticBadge": `LeadGenIndex_staticBadge__iAcng`,
	"validationSummary": `LeadGenIndex_validationSummary__xZwTa`,
	"modalActions": `LeadGenIndex_modalActions__XnvTq`,
	"modalActionsLeft": `LeadGenIndex_modalActionsLeft__B0bx9`,
	"modalActionsRight": `LeadGenIndex_modalActionsRight__owFIt`,
	"shortcutHint": `LeadGenIndex_shortcutHint__D7b-K`,
	"cancelBtn": `LeadGenIndex_cancelBtn__BViEv`,
	"saveMappingsBtn": `LeadGenIndex_saveMappingsBtn__LyaIf`,
	"shortcutsOverlay": `LeadGenIndex_shortcutsOverlay__kwFWL`,
	"shortcutsContent": `LeadGenIndex_shortcutsContent__I6-lc`,
	"shortcutsHeader": `LeadGenIndex_shortcutsHeader__ENuJp`,
	"shortcutsCloseBtn": `LeadGenIndex_shortcutsCloseBtn__EadG3`,
	"shortcutsBody": `LeadGenIndex_shortcutsBody__HDEeT`,
	"shortcutRow": `LeadGenIndex_shortcutRow__zsYft`,
	"shortcutKey": `LeadGenIndex_shortcutKey__4yeVU`,
	"shortcutDesc": `LeadGenIndex_shortcutDesc__iPSnX`,
	"configSelectedIndicator": `LeadGenIndex_configSelectedIndicator__cY0rt`,
	"editMappingBtn": `LeadGenIndex_editMappingBtn__Iei8y`,
	"deleteMappingBtn": `LeadGenIndex_deleteMappingBtn__7E5Ng`,
	"fieldMappingsSummary": `LeadGenIndex_fieldMappingsSummary__3cUbL`,
	"mappingTags": `LeadGenIndex_mappingTags__p2Bcu`,
	"mappingTag": `LeadGenIndex_mappingTag__V3hI0`,
	"dataSourceIndicator": `LeadGenIndex_dataSourceIndicator__IMGpl`,
	"dataSourceLabel": `LeadGenIndex_dataSourceLabel__tkZGT`,
	"dataSourceValue": `LeadGenIndex_dataSourceValue__gPUHO`,
	"badgeNewTable": `LeadGenIndex_badgeNewTable__a29V+`,
	"badgeLegacy": `LeadGenIndex_badgeLegacy__dK8eQ`,
	"emptyState": `LeadGenIndex_emptyState__JLKJu`
};
export default ___CSS_LOADER_EXPORT___;
